import React, { useEffect } from "react";
import trackimg from "../assets/trackimg.webp";
import trackicon from "../assets/trackicon.webp";
import OurBlog from "./Blogs";
import Footer from "./Footer";
import Navbar from "./Navbar";

const Track = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Navbar />
      <div className="app-container">
        <div className="track-blur-top-right"></div>
        <div className="track-blur-bottom-left"></div>

        <h1 className="app-title mb-5 mt-5">Track Your Application</h1>
        <div className="tracker-wrapper">
          <div className="tracker-row">
            <div className="tracker-col form-col">
              <div className="form-card">
                <div className="form-content">
                  <h4 className="form-heading ">Application Tracker</h4>

                  <p className="form-subtitle">Let's get you started quickly!</p>

                  <div className="form-inputs">
                    <p className="input-label">Mobile No</p>
                    <input
                      type="tel"
                      placeholder="Enter Mobile Number"
                      className="input-field"
                    />

                    <p className="input-label">OTP</p>
                    <input
                      type="tel"
                      placeholder="Enter OTP"
                      className="input-field"
                    />

                    <div className="button-container">
                      <button
                        className="action-button"
                        style={{ fontFamily: "popins" }}
                      >
                        Get OTP
                        <i className="fas fa-arrow-right ms-2 ms-md-3"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="tracker-col image-col">
              <div className="image-card">
                <h3 className="image-card-title">
                  Track Your loan <br />
                  application in <br />
                  real time
                </h3>

                <div className="circle-gradient"></div>

                <img
                  src={trackimg}
                  alt="Application Tracking"
                  className="tracker-image"
                />
                <img
                  src={trackicon}
                  alt="Application Tracking"
                  className="tracker-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <OurBlog />
      <Footer />
    </>
  );
};

export default Track;
